/**
 * 全局常量：路由路径、应用配置、导航项配置
 */

/** 路由路径常量 */
export const ROUTE_PATHS = {
  /** 首页仪表盘 */
  HOME: '/',
  /** 服务能力 */
  SERVICE_CAPABILITY: '/service-capability',
  /** 技术认证资质 */
  TECH_CERTIFICATIONS: '/service-capability/tech-certifications',
  /** 服务能力矩阵 */
  CAPABILITY_MATRIX: '/service-capability/capability-matrix',
  /** 典型案例库 */
  CASE_LIBRARY: '/service-capability/case-library',
  /** 工程师团队 */
  ENGINEER_TEAM: '/service-capability/engineer-team',
  /** 方案产品组合 */
  SOLUTION_PORTFOLIO: '/service-capability/solution-portfolio',
  /** 方案设计能力 */
  SOLUTION_DESIGN: '/service-capability/solution-design',
  /** 演示与POC资源 */
  POC_RESOURCES: '/service-capability/poc-resources',
  /** 行业化解决方案 */
  INDUSTRY_SOLUTIONS: '/service-capability/industry-solutions',
  /** 合规证书管理 */
  COMPLIANCE_CERTIFICATES: '/service-capability/compliance-certificates',
  /** 服务质量审核 */
  QUALITY_AUDIT: '/service-capability/quality-audit',
  /** SLA承诺标准 */
  SLA_STANDARDS: '/service-capability/sla-standards',
  /** 资质升级申请 */
  UPGRADE_APPLICATION: '/service-capability/upgrade-application',
  /** 学习资料 */
  LEARNING_MATERIALS: '/service-capability/learning-materials',
  /** 线上试题库 */
  EXAM_BANK: '/service-capability/exam-bank',
  /** 课程管理 */
  COURSE_MANAGEMENT: '/service-capability/course-management',
  /** 学习情况 */
  LEARNING_PROGRESS: '/service-capability/learning-progress',
  /** 项目管理 */
  PROJECTS: '/projects',
  /** 项目管理 - 项目报备 */
  PROJECTS_NEW_REGISTRATION: '/projects/new-registration',
  /** 项目管理 - 报备列表 */
  PROJECTS_REGISTRATION_LIST: '/projects/registration-list',
  /** 项目管理 - 报备审核 */
  PROJECTS_REGISTRATION_REVIEW: '/projects/registration-review',
  /** 项目管理 - 查机会点 */
  PROJECTS_OPPORTUNITIES: '/projects/opportunities',
  /** 项目管理 - 机会分析 */
  PROJECTS_OPPORTUNITY_ANALYSIS: '/projects/opportunity-analysis',
  /** 项目管理 - 机会推荐 */
  PROJECTS_OPPORTUNITY_RECOMMENDATION: '/projects/opportunity-recommendation',
  /** 项目管理 - 特价申请 */
  PROJECTS_SPECIAL_PRICING: '/projects/special-pricing',
  /** 项目管理 - 返点申请 */
  PROJECTS_REBATE_APPLICATION: '/projects/rebate-application',
  /** 项目管理 - 合同申请 */
  PROJECTS_CONTRACT_APPLICATION: '/projects/contract-application',
  /** 项目管理 - 授权函申请 */
  PROJECTS_AUTHORIZATION_LETTER: '/projects/authorization-letter',
  /** 项目管理 - 承诺函申请 */
  PROJECTS_COMMITMENT_LETTER: '/projects/commitment-letter',
  /** 项目管理 - 资料申请 */
  PROJECTS_MATERIAL_REQUEST: '/projects/material-request',
  /** 业绩与收益 */
  PERFORMANCE: '/performance',
  /** 业绩与收益 - 业绩看板 */
  PERFORMANCE_OVERVIEW: '/performance/overview',
  /** 业绩与收益 - 业绩趋势 */
  PERFORMANCE_TRENDS: '/performance/trends',
  /** 业绩与收益 - 目标达成 */
  PERFORMANCE_TARGET_ACHIEVEMENT: '/performance/target-achievement',
  /** 业绩与收益 - 分润明细 */
  PERFORMANCE_COMMISSION_DETAILS: '/performance/commission-details',
  /** 业绩与收益 - 分润结算 */
  PERFORMANCE_COMMISSION_SETTLEMENT: '/performance/commission-settlement',
  /** 业绩与收益 - 分润报表 */
  PERFORMANCE_COMMISSION_REPORT: '/performance/commission-report',
  /** 业绩与收益 - 奖励政策 */
  PERFORMANCE_REWARD_POLICY: '/performance/reward-policy',
  /** 业绩与收益 - 奖励明细 */
  PERFORMANCE_REWARD_DETAILS: '/performance/reward-details',
  /** 业绩与收益 - 奖励排行 */
  PERFORMANCE_REWARD_RANKING: '/performance/reward-ranking',
  /** 业绩与收益 - 项目分析 */
  PERFORMANCE_PROJECT_ANALYSIS: '/performance/project-analysis',
  /** 业绩与收益 - 客户分析 */
  PERFORMANCE_CUSTOMER_ANALYSIS: '/performance/customer-analysis',
  /** 业绩与收益 - 区域分析 */
  PERFORMANCE_REGION_ANALYSIS: '/performance/region-analysis',
  /** 资源中心 */
  RESOURCES: '/resources',
  /** 资源中心 - 产品手册 */
  RESOURCES_PRODUCT_BROCHURES: '/resources/product-brochures',
  /** 资源中心 - 宣传视频 */
  RESOURCES_PROMOTIONAL_VIDEOS: '/resources/promotional-videos',
  /** 资源中心 - 海报图片 */
  RESOURCES_POSTERS: '/resources/posters',
  /** 资源中心 - 成功案例 */
  RESOURCES_SUCCESS_CASES: '/resources/success-cases',
  /** 资源中心 - 方案白皮书 */
  RESOURCES_WHITEPAPERS: '/resources/whitepapers',
  /** 资源中心 - 技术规格 */
  RESOURCES_TECH_SPECS: '/resources/tech-specs',
  /** 资源中心 - 接口文档 */
  RESOURCES_API_DOCS: '/resources/api-docs',
  /** 资源中心 - 认证培训 */
  RESOURCES_CERT_TRAINING: '/resources/cert-training',
  /** 资源中心 - 产品培训 */
  RESOURCES_PRODUCT_TRAINING: '/resources/product-training',
  /** 资源中心 - 销售培训 */
  RESOURCES_SALES_TRAINING: '/resources/sales-training',
  /** 资源中心 - 合同范本 */
  RESOURCES_CONTRACT_TEMPLATES: '/resources/contract-templates',
  /** 资源中心 - 协议模板 */
  RESOURCES_AGREEMENT_TEMPLATES: '/resources/agreement-templates',
  /** 资源中心 - 法律文件 */
  RESOURCES_LEGAL_DOCS: '/resources/legal-docs',
  /** 配置报价器 */
  QUOTATION: '/quotation',
  /** 配置报价器 - 服务器与存储 */
  QUOTATION_SERVER_STORAGE: '/quotation/server-storage',
  /** 配置报价器 - 网络设备 */
  QUOTATION_NETWORK_DEVICES: '/quotation/network-devices',
  /** 配置报价器 - 安全设备 */
  QUOTATION_SECURITY_DEVICES: '/quotation/security-devices',
  /** 配置报价器 - 软件产品 */
  QUOTATION_SOFTWARE_PRODUCTS: '/quotation/software-products',
  /** 配置报价器 - 我的订单 */
  QUOTATION_MY_ORDERS: '/quotation/my-orders',
  /** 配置报价器 - 报价单列表 */
  QUOTATION_QUOTE_LIST: '/quotation/quote-list',
  /** 配置报价器 - 共享报价单 */
  QUOTATION_SHARED_QUOTES: '/quotation/shared-quotes',
  /** 配置报价器 - 报价模板 */
  QUOTATION_QUOTE_TEMPLATES: '/quotation/quote-templates',
  /** 配置报价器 - 已删除报价单 */
  QUOTATION_TRASH: '/quotation/trash',
  /** 配置报价器 - 回收站设置 */
  QUOTATION_TRASH_SETTINGS: '/quotation/trash-settings',
  /** 配置报价器 - 恢复记录 */
  QUOTATION_RESTORE_HISTORY: '/quotation/restore-history',
  /** 配置报价器 - 导出报价单 */
  QUOTATION_EXPORT_QUOTE: '/quotation/export-quote',
  /** 配置报价器 - 导出记录 */
  QUOTATION_EXPORT_HISTORY: '/quotation/export-history',
  /** 配置报价器 - 导出模板管理 */
  QUOTATION_EXPORT_TEMPLATES: '/quotation/export-templates',
  /** 公司信息设置 */
  SETTINGS_COMPANY: '/settings/company',
  /** 常用联系人管理 */
  SETTINGS_CONTACTS: '/settings/contacts',
  /** 政策公告列表 */
  ANNOUNCEMENTS_POLICIES: '/announcements/policies',
  /** 市场活动列表 */
  EVENTS_MARKETING: '/events/marketing',
  /** 健康度看板 */
  HEALTH: '/health',
  /** MDF市场发展基金 */
  MDF: '/mdf',
} as const;

/** 顶部导航项配置 */
export interface NavItemConfig {
  /** 导航项标签 */
  label: string;
  /** 路由路径 */
  path: string;
  /** 图标组件名（MUI Icons named export） */
  icon: string;
}

/** 顶部导航栏 6 个导航项 */
export const TOP_NAV_ITEMS: NavItemConfig[] = [
  { label: '认证管理', path: ROUTE_PATHS.HOME, icon: 'Verified' },
  { label: '服务能力', path: ROUTE_PATHS.SERVICE_CAPABILITY, icon: 'Engineering' },
  { label: '项目管理', path: ROUTE_PATHS.PROJECTS, icon: 'Assignment' },
  { label: '业绩与利益', path: ROUTE_PATHS.PERFORMANCE, icon: 'TrendingUp' },
  { label: '资源中心', path: ROUTE_PATHS.RESOURCES, icon: 'Inventory2' },
  { label: '配置报价器', path: ROUTE_PATHS.QUOTATION, icon: 'RequestQuote' },
];

/** 官网外链 */
export const OFFICIAL_WEBSITE_URL = 'http://hongyuict.com/';

/** 联系电话 */
export const CONTACT_PHONE = '400-773-5885';

/** 联系邮箱 */
export const CONTACT_EMAIL = 'service@hongyuict.com';
/** 版权信息 */
export const COPYRIGHT_TEXT = '版权所有 © 2018-2026 四川虹宇创发科技有限公司 蜀ICP备2021003724号-1';

